import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getProducts } from "@/lib/api";
import { ProductCard } from "@/components/ProductCard";

const TABS = [
  { key: "best", label: "Best Sellers", testid: "tab-best-sellers" },
  { key: "new", label: "New Arrivals", testid: "tab-new-arrivals" },
  { key: "offers", label: "Special Offers", testid: "tab-special-offers" },
];

export const Bestsellers = () => {
  const [products, setProducts] = useState([]);
  const [tab, setTab] = useState("best");

  useEffect(() => {
    getProducts().then(setProducts).catch(() => {});
  }, []);

  const lists = {
    best: products.filter((p) => ["Bestseller", "Popular"].includes(p.badge)),
    new: products.filter((p) => p.badge === "New"),
    offers: products
      .filter((p) => p.mrp > p.price)
      .sort((a, b) => 1 - b.price / b.mrp - (1 - a.price / a.mrp)),
  };

  const available = TABS.filter((t) => lists[t.key].length > 0);
  if (available.length === 0) return null;
  const activeTab = lists[tab]?.length ? tab : available[0].key;
  const visible = lists[activeTab].slice(0, 4);

  return (
    <section className="pt-20 md:pt-24" data-testid="bestsellers-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-wrap items-end justify-between gap-6"
        >
          <div>
            <p className="text-xs uppercase tracking-[0.25em] font-bold text-primary mb-4">Loved across India</p>
            <h2 className="font-serif text-3xl md:text-5xl font-medium tracking-tight leading-tight">
              This season's <span className="italic text-primary">most reordered.</span>
            </h2>
          </div>
          <div className="flex gap-2" data-testid="bestseller-tabs">
            {available.map((t) => (
              <button
                key={t.key}
                data-testid={t.testid}
                onClick={() => setTab(t.key)}
                className={`rounded-full px-5 py-2.5 text-xs font-bold uppercase tracking-[0.1em] transition-all duration-300 ${
                  activeTab === t.key
                    ? "bg-primary text-primary-foreground shadow-md"
                    : "bg-secondary/60 text-muted-foreground hover:bg-secondary hover:text-foreground"
                }`}
              >
                {t.label}
              </button>
            ))}
          </div>
        </motion.div>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="bestseller-grid">
          {visible.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};
